import { shortAccount } from '../../../utils/traderFormat';
import type {
    PositionPoint,
    WalletPosition,
} from '../../wallets/useWalletPositions';
import type { ChartSeries, SeriesPoint } from '../seriesTypes';

export type PositionMode = 'sides' | 'net';

export function netPosition(position: WalletPosition): SeriesPoint[] {
    const times = [
        ...new Set([...position.yes, ...position.no].map(p => p.t)),
    ].sort((a, b) => a - b);
    const points: SeriesPoint[] = [];
    let yes = 0;
    let no = 0;
    let iYes = 0;
    let iNo = 0;
    for (const t of times) {
        while (iYes < position.yes.length && position.yes[iYes].t <= t) {
            yes = position.yes[iYes].v;
            iYes += 1;
        }
        while (iNo < position.no.length && position.no[iNo].t <= t) {
            no = position.no[iNo].v;
            iNo += 1;
        }
        points.push({ t, v: yes - no });
    }
    return points;
}

function line(
    id: string,
    label: string,
    color: string,
    points: readonly PositionPoint[],
    dashed: boolean
): ChartSeries {
    return {
        id,
        label,
        color,
        unit: 'shares',
        draw: 'step',
        axis: 'shared',
        home: 'position',
        movable: true,
        hasData: points.length > 0,
        dashed,
        data: { kind: 'points', points: points.map(p => ({ ...p })) },
    };
}

export function positionSeries(
    positionsByWallet: ReadonlyMap<string, WalletPosition>,
    colors: ReadonlyMap<string, string>,
    mode: PositionMode = 'sides'
): ChartSeries[] {
    const result: ChartSeries[] = [];
    for (const [wallet, position] of positionsByWallet) {
        const color = colors.get(wallet) ?? '#888888';
        const name = shortAccount(wallet);
        if (mode === 'net') {
            result.push(
                line(
                    `pos:${wallet}`,
                    `${name} net`,
                    color,
                    netPosition(position),
                    false
                )
            );
            continue;
        }
        result.push(
            line(`pos:${wallet}:yes`, `${name} YES`, color, position.yes, false)
        );
        result.push(
            line(`pos:${wallet}:no`, `${name} NO`, color, position.no, true)
        );
    }
    return result;
}
